export default __webpack_public_path__ + "static/media/Rectangle-logo.c59b80ff.png";